// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyListWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentalManagerUserPropertyListAtRiskDto, RentalManagerUserPropertyListDto } from '../..';

interface AtRiskParams {
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRisk?: boolean;
  includeFeedClaimAndConvertUpdate?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeTours?: boolean;
  includeUnarchived?: boolean;
  includeUserManagementCompanyId?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}

export const RentalManagerUserPropertyListWebApiHandler_atRisk_Path = '/api/web/v1/users/properties/list/atRisk';

/**
 * List a user's properties that are at risk
 */
export const RentalManagerUserPropertyListWebApiHandler_atRisk = (getParams: AtRiskParams, client = getClient()) => {
  return httpFrontEndRequest<AtRiskParams, never, RentalManagerUserPropertyListAtRiskDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListWebApiHandler_atRisk_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyListWebApiHandler_list_Path = '/api/web/v1/users/properties/list';

/**
 * List a user's properties
 */
export const RentalManagerUserPropertyListWebApiHandler_list = (getParams: ListParams, client = getClient()) => {
  return httpFrontEndRequest<ListParams, never, RentalManagerUserPropertyListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
